import * as i0 from '@angular/core';
import { Component, inject, ChangeDetectorRef, Injector, Injectable, EventEmitter, ViewContainerRef, ViewChild, Output, ApplicationRef, EnvironmentInjector, createComponent, Inject, APP_INITIALIZER } from '@angular/core';
import { BehaviorSubject, Subject, filter, map, take } from 'rxjs';
import { NgStyle, DOCUMENT } from '@angular/common';
import { trigger, state, style, transition, group, animate, query, animateChild } from '@angular/animations';
import { provideAnimations } from '@angular/platform-browser/animations';

class DefaultLoaderComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DefaultLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.4", type: DefaultLoaderComponent, isStandalone: true, selector: "ng-vibe-drawer-default-loader", ngImport: i0, template: "<div class=\"box-position\">\n  <div class=\"loader-center\">\n    <span class=\"loader\"></span>\n  </div>\n</div>\n", styles: [".box-position{height:auto;left:50%;margin:0 auto;position:absolute;text-align:center;top:50%;transform:translate(-50%,-40%)}.box-position .loader-center{align-items:center;display:flex;justify-content:center}.box-position .loader-center .loader{width:48px;height:48px;display:inline-block;position:relative}.box-position .loader-center .loader:after,.box-position .loader-center .loader:before{content:\"\";box-sizing:border-box;width:48px;height:48px;border-radius:50%;background:var(--drawer-default-loader-color);position:absolute;left:0;top:0;animation:animloader 2s linear infinite;opacity:0}.box-position .loader-center .loader:after{animation-delay:1s}@keyframes animloader{0%{transform:scale(0);opacity:1}to{transform:scale(1);opacity:0}}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DefaultLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-vibe-drawer-default-loader', standalone: true, template: "<div class=\"box-position\">\n  <div class=\"loader-center\">\n    <span class=\"loader\"></span>\n  </div>\n</div>\n", styles: [".box-position{height:auto;left:50%;margin:0 auto;position:absolute;text-align:center;top:50%;transform:translate(-50%,-40%)}.box-position .loader-center{align-items:center;display:flex;justify-content:center}.box-position .loader-center .loader{width:48px;height:48px;display:inline-block;position:relative}.box-position .loader-center .loader:after,.box-position .loader-center .loader:before{content:\"\";box-sizing:border-box;width:48px;height:48px;border-radius:50%;background:var(--drawer-default-loader-color);position:absolute;left:0;top:0;animation:animloader 2s linear infinite;opacity:0}.box-position .loader-center .loader:after{animation-delay:1s}@keyframes animloader{0%{transform:scale(0);opacity:1}to{transform:scale(1);opacity:0}}\n"] }]
        }] });

var AnimationEnum;
(function (AnimationEnum) {
    AnimationEnum["OPEN"] = "open";
    AnimationEnum["CLOSED"] = "closed";
})(AnimationEnum || (AnimationEnum = {}));

var DrawerPosition;
(function (DrawerPosition) {
    DrawerPosition["RIGHT"] = "right";
    DrawerPosition["LEFT"] = "left";
    DrawerPosition["TOP"] = "top";
    DrawerPosition["BOTTOM"] = "bottom";
})(DrawerPosition || (DrawerPosition = {}));

const drawerAnimations = trigger('drawerAnimations', [
    // States
    state(`${DrawerPosition.LEFT}_${AnimationEnum.OPEN}`, style({ transform: 'translateX(0)' })),
    state(`${DrawerPosition.LEFT}_${AnimationEnum.CLOSED}`, style({ transform: 'translateX(-100%)' })),
    state(`${DrawerPosition.RIGHT}_${AnimationEnum.OPEN}`, style({ transform: 'translateX(0)' })),
    state(`${DrawerPosition.RIGHT}_${AnimationEnum.CLOSED}`, style({ transform: 'translateX(100%)' })),
    state(`${DrawerPosition.TOP}_${AnimationEnum.OPEN}`, style({ transform: 'translateY(0)' })),
    state(`${DrawerPosition.TOP}_${AnimationEnum.CLOSED}`, style({ transform: 'translateY(-100%)' })),
    state(`${DrawerPosition.BOTTOM}_${AnimationEnum.OPEN}`, style({ transform: 'translateY(0)' })),
    state(`${DrawerPosition.BOTTOM}_${AnimationEnum.CLOSED}`, style({ transform: 'translateY(100%)' })),
    // Transitions
    transition(`${DrawerPosition.LEFT}_${AnimationEnum.CLOSED} => ${DrawerPosition.LEFT}_${AnimationEnum.OPEN}`, group([
        animate('0.5s ease-out', style({ transform: 'translateX(0)' })),
        query('@*', animateChild(), { optional: true }),
    ])),
    transition(`${DrawerPosition.LEFT}_${AnimationEnum.OPEN} => ${DrawerPosition.LEFT}_${AnimationEnum.CLOSED}`, group([
        query('@*', animateChild(), { optional: true }),
        animate('0.3s ease-in', style({ transform: 'translateX(-100%)' })),
    ])),
    transition(`${DrawerPosition.RIGHT}_${AnimationEnum.CLOSED} => ${DrawerPosition.RIGHT}_${AnimationEnum.OPEN}`, group([
        animate('0.5s ease-out', style({ transform: 'translateX(0)' })),
        query('@*', animateChild(), { optional: true }),
    ])),
    transition(`${DrawerPosition.RIGHT}_${AnimationEnum.OPEN} => ${DrawerPosition.RIGHT}_${AnimationEnum.CLOSED}`, group([
        query('@*', animateChild(), { optional: true }),
        animate('0.3s ease-in', style({ transform: 'translateX(100%)' })),
    ])),
    transition(`${DrawerPosition.TOP}_${AnimationEnum.CLOSED} => ${DrawerPosition.TOP}_${AnimationEnum.OPEN}`, group([
        animate('0.5s ease-out', style({ transform: 'translateY(0)' })),
        query('@*', animateChild(), { optional: true }),
    ])),
    transition(`${DrawerPosition.TOP}_${AnimationEnum.OPEN} => ${DrawerPosition.TOP}_${AnimationEnum.CLOSED}`, group([
        query('@*', animateChild(), { optional: true }),
        animate('0.3s ease-in', style({ transform: 'translateY(-100%)' })),
    ])),
    transition(`${DrawerPosition.BOTTOM}_${AnimationEnum.CLOSED} => ${DrawerPosition.BOTTOM}_${AnimationEnum.OPEN}`, group([
        animate('0.5s ease-out', style({ transform: 'translateY(0)' })),
        query('@*', animateChild(), { optional: true }),
    ])),
    transition(`${DrawerPosition.BOTTOM}_${AnimationEnum.OPEN} => ${DrawerPosition.BOTTOM}_${AnimationEnum.CLOSED}`, group([
        query('@*', animateChild(), { optional: true }),
        animate('0.3s ease-in', style({ transform: 'translateY(100%)' })),
    ])),
]);

const fadeinOutAnimation = trigger('fadeinOutAnimation', [
    state('enter', style({ opacity: 1 })),
    state('leave', style({ opacity: 0 })),
    transition('* => enter', [
        style({ opacity: 0 }),
        group([
            animate('300ms ease-in', style({ opacity: 1 })),
            query('@*', animateChild(), { optional: true }),
        ]),
    ]),
    transition('enter => leave', [
        group([
            query('@*', animateChild(), { optional: true }),
            animate('300ms ease-out', style({ opacity: 0 })),
        ]),
    ]),
]);

const overlayAnimation = trigger('overlayAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
    ]),
    transition(':leave', [animate('600ms ease-out', style({ opacity: 0 }))]),
]);

const DEFAULT_DRAWER_OPTIONS_LEFT = {
    width: '30%',
    height: '100%',
    position: DrawerPosition.LEFT,
    showOverlay: true,
};
const DEFAULT_DRAWER_OPTIONS_RIGHT = {
    width: '30%',
    height: '100%',
    position: DrawerPosition.RIGHT,
    showOverlay: true,
};
const DEFAULT_DRAWER_OPTIONS_TOP = {
    width: '100%',
    height: '30%',
    position: DrawerPosition.TOP,
    showOverlay: true,
};
const DEFAULT_DRAWER_OPTIONS_BOTTOM = {
    width: '100%',
    height: '30%',
    position: DrawerPosition.BOTTOM,
    showOverlay: true,
};

function setupServiceLocator(injector) {
    ServiceLocator.injector = injector;
}
class ServiceLocator {
}

function generateRandomString() {
    return Math.random().toString(36).substring(2, 12);
}

/**
 * Provides control over a specific drawer instance, enabling the manipulation of drawer states and configuration.
 */
class DrawerRemoteControl {
    #options;
    #childComponent;
    #loaderComponent;
    /**
     * Sets drawer options, merging provided options with the default drawer options.
     * @param {Partial<IDrawerOptions>} options - Custom options to configure the drawer.
     */
    set options(options) {
        this.#options = {
            ...this.#options,
            ...this.#preSetup(options),
        };
    }
    /**
     * Returns the current configuration options of the drawer.
     * @returns {IDrawerOptions} The current set of drawer options.
     */
    get options() {
        return this.#options;
    }
    constructor(component) {
        /** A unique identifier for the drawer instance. */
        this.id = generateRandomString();
        this.#options = DEFAULT_DRAWER_OPTIONS_RIGHT;
        /** Custom payload data that can be passed to the drawer. */
        this.payload = null;
        this.#childComponent = component;
        this.drawerService = ServiceLocator.injector.get(DrawerService);
    }
    /**
     * Configures the drawer to show a loader until explicitly stopped. Optionally, a custom loader component can be provided.
     * @param {Type<any>=} component - The component to use as a loader. If not provided, a default loader is used.
     */
    withLoader(component) {
        this.#loaderComponent = component || DefaultLoaderComponent;
    }
    /**
     * Placeholder for stopping the loader. Implement this method based on your drawer service's capability to handle loader components.
     */
    stopLoader() {
        this.drawerService.removeLoaderComponent(this.id);
    }
    /**
     * Opens the drawer with the configured settings and component. Optionally, a payload can be passed to the drawer component.
     * @param {any=} payload - Custom data to be passed to the drawer component.
     * @returns {Observable<any>} - An Observable that emits when the drawer is closed, returning any result data.
     */
    openDrawer(payload) {
        this.payload = payload || null;
        return this.drawerService.open(this, this.#childComponent, this.#loaderComponent);
    }
    /**
     * Closes the drawer and optionally returns data to the opener.
     * @param {any=} data - Optional data to return as the result of the drawer closing.
     */
    closeDrawer(data) {
        this.drawerService.close(this.id, data);
    }
    #preSetup(options) {
        let preSetup = DEFAULT_DRAWER_OPTIONS_LEFT;
        switch (options.position) {
            case DrawerPosition.LEFT: {
                preSetup = {
                    ...DEFAULT_DRAWER_OPTIONS_LEFT,
                    ...options,
                };
                break;
            }
            case DrawerPosition.RIGHT: {
                preSetup = {
                    ...DEFAULT_DRAWER_OPTIONS_RIGHT,
                    ...options,
                };
                break;
            }
            case DrawerPosition.TOP: {
                preSetup = {
                    ...DEFAULT_DRAWER_OPTIONS_TOP,
                    ...options,
                };
                break;
            }
            case DrawerPosition.BOTTOM: {
                preSetup = {
                    ...DEFAULT_DRAWER_OPTIONS_BOTTOM,
                    ...options,
                };
                break;
            }
        }
        return preSetup;
    }
}

function provideRemoteControl(remoteControl) {
    return [
        {
            provide: DrawerRemoteControl,
            useValue: remoteControl,
        },
    ];
}

class DrawerComponentHelperService {
    constructor() {
        this.cd = inject(ChangeDetectorRef);
    }
    loadComponent(content, remoteControl, componentType) {
        if (!content || !componentType)
            return; // Guard condition
        const injector = Injector.create({
            providers: provideRemoteControl(remoteControl),
        });
        content.clear();
        content.createComponent(componentType, { injector });
        this.cd.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerComponentHelperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerComponentHelperService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerComponentHelperService, decorators: [{
            type: Injectable
        }] });

class StateManagementService {
    constructor() {
        this.instanceStatesSubject = new BehaviorSubject(new Map());
        this.instanceStates$ = this.instanceStatesSubject.asObservable();
        this.instances = new Map();
        this.instanceCloseSubject = new Subject();
    }
    addInstance(id, componentRef, remoteControl) {
        this.instances.set(id, componentRef);
        this.updateState(id, remoteControl);
    }
    instanceExists(id) {
        return this.instances.has(id);
    }
    getInstance(id) {
        return this.instances.get(id);
    }
    deleteInstance(id) {
        return this.instances.delete(id);
    }
    getDialogStates$() {
        return this.instanceStatesSubject.asObservable();
    }
    getDialogCloseSubject() {
        return this.instanceCloseSubject;
    }
    listenForClose(id) {
        return this.instanceCloseSubject.asObservable().pipe(filter((event) => event.id === id), map((event) => event.data), take(1));
    }
    updateState(id, remoteControl) {
        const currentStates = this.instanceStatesSubject.getValue();
        currentStates.set(id, remoteControl);
        this.instanceStatesSubject.next(currentStates);
    }
    removeDialogState(id) {
        const currentStates = this.instanceStatesSubject.getValue();
        if (currentStates.delete(id)) {
            this.instanceStatesSubject.next(currentStates);
        }
    }
    sendCloseData(id, data) {
        this.instanceCloseSubject.next({ id, data });
    }
    closeEmmit(id, data) {
        this.deleteInstance(id);
        this.removeDialogState(id);
        this.sendCloseData(id, data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StateManagementService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StateManagementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: StateManagementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DrawerComponent {
    constructor() {
        this.animationDone = new EventEmitter();
        this.overlayVisible = false;
        this.contentAnimationState = 'enter';
        this.helper = inject(DrawerComponentHelperService);
    }
    ngAfterViewInit() {
        this.overlayVisible = this.options.showOverlay;
        this.animationState = `${this.options.position}_${AnimationEnum.OPEN}`;
        this.loadComponent();
    }
    prepareComponentForLoad(component, remoteControl) {
        this.mainComponentType = component;
        this.drawerRemoteControl = remoteControl;
        if (!this.loaderComponentType) {
            // If no loader, load the main component immediately
            this.loadComponent();
        }
    }
    stopLoader() {
        if (this.loaderComponentType) {
            this.contentAnimationState = 'leave';
            // timeout for smooth animation
            setTimeout(() => {
                this.loaderComponentType = undefined; // Clear loader component
                this.loadComponent(); // Load main component
            }, 400);
        }
    }
    setLoaderComponent(component) {
        this.loaderComponentType = component;
    }
    loadComponent() {
        const componentType = this.loaderComponentType || this.mainComponentType;
        this.contentAnimationState = 'enter';
        this.helper.loadComponent(this.drawerContent, this.drawerRemoteControl, componentType);
    }
    onAnimationDone(event) {
        if (event.toState === `${this.options.position}_${AnimationEnum.CLOSED}`) {
            this.animationDone.emit();
        }
    }
    onAnimationStart(event) {
        if (event.fromState === `${this.options.position}_${AnimationEnum.OPEN}`) {
            this.overlayVisible = false;
        }
    }
    getDrawerStyles() {
        const styles = {
            width: this.options.width,
            height: this.options.height,
        };
        switch (this.options.position) {
            case DrawerPosition.LEFT:
                styles['left'] = '0';
                styles['bottom'] = '0';
                styles['top'] = '0';
                break;
            case DrawerPosition.RIGHT:
                styles['right'] = '0';
                styles['bottom'] = '0';
                styles['top'] = '0';
                break;
            case DrawerPosition.TOP:
                styles['top'] = '0';
                styles['left'] = '0';
                styles['right'] = '0';
                break;
            case DrawerPosition.BOTTOM:
                styles['bottom'] = '0';
                styles['left'] = '0';
                styles['right'] = '0';
                break;
        }
        return styles;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.2.4", type: DrawerComponent, isStandalone: true, selector: "ng-vibe-drawer", outputs: { animationDone: "animationDone" }, providers: [DrawerComponentHelperService], viewQueries: [{ propertyName: "drawerContent", first: true, predicate: ["drawerContent"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: "@if (overlayVisible) {\n<div class=\"ng-vibe-drawer-overlay\" @overlayAnimation></div>\n}\n<div\n  [@drawerAnimations]=\"animationState\"\n  (@drawerAnimations.done)=\"onAnimationDone($event)\"\n  (@drawerAnimations.start)=\"onAnimationStart($event)\"\n  [ngStyle]=\"getDrawerStyles()\"\n  class=\"ng-vibe-drawer-wrapper\"\n>\n  <div class=\"drawer-content\" [@fadeinOutAnimation]=\"contentAnimationState\">\n    <ng-template #drawerContent></ng-template>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], animations: [drawerAnimations, overlayAnimation, fadeinOutAnimation] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-vibe-drawer', standalone: true, imports: [NgStyle], animations: [drawerAnimations, overlayAnimation, fadeinOutAnimation], providers: [DrawerComponentHelperService], template: "@if (overlayVisible) {\n<div class=\"ng-vibe-drawer-overlay\" @overlayAnimation></div>\n}\n<div\n  [@drawerAnimations]=\"animationState\"\n  (@drawerAnimations.done)=\"onAnimationDone($event)\"\n  (@drawerAnimations.start)=\"onAnimationStart($event)\"\n  [ngStyle]=\"getDrawerStyles()\"\n  class=\"ng-vibe-drawer-wrapper\"\n>\n  <div class=\"drawer-content\" [@fadeinOutAnimation]=\"contentAnimationState\">\n    <ng-template #drawerContent></ng-template>\n  </div>\n</div>\n" }]
        }], propDecorators: { drawerContent: [{
                type: ViewChild,
                args: ['drawerContent', { read: ViewContainerRef }]
            }], animationDone: [{
                type: Output
            }] } });

class HelperService {
    constructor(document) {
        this.document = document;
        this.appRef = inject(ApplicationRef);
        this.environmentInjector = inject(EnvironmentInjector);
    }
    manageView(action, componentRef) {
        if (action === 'attach') {
            this.appRef.attachView(componentRef.hostView);
            this.document.body.appendChild(componentRef.location.nativeElement);
        }
        else if (action === 'detach') {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        }
    }
    createAndConfigureDynamicComponents(remoteControl, childComponent, parentComponent, loaderComponent) {
        const parentComponentRef = createComponent(parentComponent, {
            environmentInjector: this.environmentInjector,
        });
        if (loaderComponent) {
            parentComponentRef.instance.setLoaderComponent(loaderComponent);
        }
        parentComponentRef.instance.prepareComponentForLoad(childComponent, remoteControl);
        parentComponentRef.instance.options = remoteControl.options;
        parentComponentRef.instance.animationState = `${remoteControl.options.position}_${AnimationEnum.CLOSED}`;
        return parentComponentRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HelperService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HelperService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: HelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class DrawerService {
    constructor() {
        this.helperService = inject(HelperService);
        this.stateService = inject(StateManagementService);
    }
    open(remoteControl, childComponent, loaderComponent) {
        if (this.stateService.instanceExists(remoteControl.id)) {
            return this.stateService.listenForClose(remoteControl.id);
        }
        console.log('loaderComponent', loaderComponent);
        const parentComponentRef = this.helperService.createAndConfigureDynamicComponents(remoteControl, childComponent, DrawerComponent, loaderComponent);
        this.stateService.addInstance(remoteControl.id, parentComponentRef, remoteControl);
        this.helperService.manageView('attach', parentComponentRef);
        return this.stateService.listenForClose(remoteControl.id);
    }
    removeLoaderComponent(id) {
        const dialogComponentRef = this.stateService.getInstance(id);
        if (dialogComponentRef) {
            dialogComponentRef.instance.stopLoader();
        }
    }
    close(id, data) {
        const parentRef = this.stateService.getInstance(id);
        if (parentRef) {
            parentRef.instance.animationState = `${parentRef.instance.options.position}_${AnimationEnum.CLOSED}`;
            parentRef.instance.contentAnimationState = 'leave';
            parentRef.instance.animationDone.pipe(take(1)).subscribe(() => {
                this.helperService.manageView('detach', parentRef);
                this.stateService.closeEmmit(id, data);
            });
        }
    }
    closeAll() {
        const dialogs = this.stateService.instances;
        dialogs.forEach((drawerComponentRef, id) => {
            this.close(id);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: DrawerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class PublicDrawerService {
    constructor() {
        this.service = inject(DrawerService);
        this.state = inject(StateManagementService);
        /**
         * An Observable that emits the count of active drawers by listening to the state changes
         * and calculates the total amount active drawers.
         */
        this.activeDrawersCount$ = this.state.instanceStates$.pipe(map((states) => Array.from(states.values()).length));
    }
    /**
     * Retrieves the RemoteControl object associated with a specific drawer ID.
     * @param {string} id The unique identifier for the drawer.
     * @returns {DrawerRemoteControl | undefined} The RemoteControl object if found, otherwise undefined.
     */
    getRemoteControl(id) {
        return this.state.instanceStatesSubject.getValue().get(id);
    }
    /**
     * Returns an Observable that emits the RemoteControl object for a given drawer ID.
     * The Observable filters out any undefined states, ensuring subscribers only receive defined RemoteControl objects.
     * @param {string} id The unique identifier for the drawer.
     * @returns {Observable<DrawerRemoteControl | undefined>} An Observable emitting the RemoteControl object or undefined.
     */
    selectRemoteControl$(id) {
        return this.state.instanceStates$.pipe(map((states) => states.get(id)), filter((state) => state !== undefined));
    }
    /**
     * Triggers the closing of all drawers.
     */
    closeAll() {
        this.service.closeAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PublicDrawerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PublicDrawerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.4", ngImport: i0, type: PublicDrawerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

function provideNgVibeDrawer() {
    return [
        provideAnimations(),
        {
            provide: APP_INITIALIZER,
            useFactory: (injector) => () => setupServiceLocator(injector),
            deps: [Injector],
            multi: true,
        },
    ];
}

/**
 * Generated bundle index. Do not edit.
 */

export { DrawerPosition, DrawerRemoteControl, PublicDrawerService as DrawerService, provideNgVibeDrawer };
